import React from "react";
import { Toaster } from "react-hot-toast";
import TrilliumLogo from "./assets/Trillium-health-logo.png";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "./Containers/Login";
import { Typography } from "@material-ui/core";
import PersonalDetails from "Containers/PersonalDetails";
import InsuranceDetails from "Containers/InsuranceDetails";
import PaymentDetails from "Containers/PaymentDetails";
import AppointmentDetails from "Containers/AppointmentDetails";
// import Stripe from "Containers/StripePayment";
// import Success from "Containers/Success";
import "./GlobalStyles.css";
import environment from "environments/environment";
import { useLogo } from "Hooks/useLogo";

function App() {
  const companyKey = environment.companyKey || 'trillium' // fallback if not set
  // const companyLogos = logoMap[companyKey] || logoMap['trillium']
  const logo =useLogo()
  return (
    <div className="app">
      <header className="trillium-health-logo-header">
        <div className="trillium-health-logo-container">
          <a href={environment.redirectUrl}>
            <img
              // src={TrilliumLogo}
              src={logo}
              // alt="trillium-health-logo"
              alt={`${environment?.companyName} logo`}
              className="trillium-health-logo"
            />
          </a>
        </div>
      </header>
      <Toaster position="top-right" reverseOrder={false} />
      <BrowserRouter>
        <React.Suspense fallback={"loading"}>
          <Routes>
            <Route path="/details" element={<PersonalDetails />} />
            <Route path="/insurance" element={<InsuranceDetails />} />
            <Route path="/payment" element={<PaymentDetails />} />
            {/*  /> */}
            {/* <Route path="/success" element={Success} /> */}
            <Route path="/appointment" element={<AppointmentDetails />} />
            <Route path="/:id" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
      <footer className="footer_container">
        <div className="copyright">
          {/* <Typography variant="caption" align="center" color="textSecondary">
            Copyright &copy; {new Date().getFullYear()}-
            {new Date().getFullYear() + 1} {environment.companyName}
          </Typography> */}
          <Typography
            variant="caption"
            align="center"
            color="textSecondary"
            display="block"
          >
            © {new Date().getFullYear()}–{new Date().getFullYear() + 1}{' '}
            {environment.companyName}. All rights reserved.
            <div>
              {environment.copyRight}
              <br />
              Unauthorized access, use, or reproduction of this application or
              its contents is strictly prohibited.
            </div>
          </Typography>
        </div>
      </footer>
    </div>
  );
}

export default App;
